import { GaugeData } from "../components/GaugeChart";
import { useBaseApi } from "./BaseApiHook";

export interface ProductAttribute {
  name: string;
  value: string;
}

export interface Product {
  id: string;
  name: string;
}

export interface ProductMetadata {
  id: string;
  name: string;
  organizationId: string;
  organizationName: string;
  collectionId: string;
  collectionName: string;
  scores: Array<GaugeData>;
  totalScore: number;
  attributes: Array<ProductAttribute>;
}

export const useProductApi = () => {
  const { request } = useBaseApi();

  return {
    GetAllProducts: async (): Promise<Array<Product>> => request("GET", "/products"),
    GetAllProductsMetadata: async (): Promise<Array<ProductMetadata>> => request("GET", "/products/metadata"),
    GetProduct: async (productId: string): Promise<Product> => request("GET", "/products/" + productId),
  }
}
